import React, { createContext, useContext, useState, useEffect } from 'react'

const HydrationContext = createContext<{ isHydrated: boolean }>({ isHydrated: false })

export function HydrationProvider({ children }: { children: React.ReactNode }) {
  const [isHydrated, setHydrated] = useState(false)
  useEffect(() => {
    setHydrated(true)
  }, [])
  return (
    <HydrationContext.Provider value={{ isHydrated }}>
      {children}
    </HydrationContext.Provider>
  )
}

export function useHydration() {
  return useContext(HydrationContext).isHydrated
}
